import {
  faArrowDownShortWide,
  faArrowDownWideShort
} from '@fortawesome/pro-solid-svg-icons';
import { sortFolderEnum } from 'enum/folder.enum';

export const directions = {
  [sortFolderEnum.asc]: faArrowDownShortWide,
  [sortFolderEnum.desc]: faArrowDownWideShort,
};

export const directionsInvert = {
  [sortFolderEnum.asc]: sortFolderEnum.desc,
  [sortFolderEnum.desc]: sortFolderEnum.asc,
};
